const jobTypes = [
  {
    id: 1,
    name: "2025 INDIVIDUAL AND SIBLING",
    kit: {
      "Studio Light": 2,
      "Power Cord (If Wired light)": 1,
      "Light Battery Charger (If Battery Light)": 1,
      "Softbox Umbrella": 2,
      "XL Stand": 1,
      "Large Stand": 3,
      "Stand Bag": 1,
      "Grey Pop Up Background": 1,
      "Floor Dots": 2,
      "Kit Box or Rucksack": 1,
      "Floor Mat": 1,
      Stools: 2,
      "Trigger (Camera Specific)": 1,
      "AA Batteries": 2,
      "Jerk Stopper": 1,
      "10m Extension Lead": 1,
      "Tri Reflector Panels": 3,
      "Tri Reflector Holder": 1,
      "Tri Reflector Stand": 1,
      "Tape Measure": 1,
      "Memory Card (Camera Specific)": 2,
      "Camera Tripod *": 1,
      "Tether Lead * (Camera & Computer Specific) ": 1,
      "Laptop *": 1,
      "Camera *": 1,
      "Camera Battery *": 2,
      "Camera Battery Charger *": 1,
      "70mm+ Lens *": 1,
      "Sync Lead *": 1,
      "Pop Up Step *": 1,
      "Barcode Scanner *": 1,
      "Light Meter *": 1,
    },
  },
  {
    id: 2,
    name: "Traditional Class",
    kit: {
      "background stands": 3,
      clipboard: 1,
      crossbar: 1,
      "curtain (singular)": 6,
      "floor dots": 5,
      "large clips": 8,
      "light stands": 2,
      lights: 2,
      trigger: 1,
      tripod: 1,
      umbrella: 2,
    },
  },

  {
    id: 3,
    name: "White Background Class",
    kit: {
      "background stands": 2,
      "light stands": 4,
      "winders & prongs (set)": 1,
      lights: 4,
      umbrella: 4,
      stool: 1,
      "floor dots": 1,
      tripod: 1,
      trigger: 1,
      clipboard: 1,
      "paper roll white": 1,
      scissors: 1,
      "floor brush": 1,
      tape: 1,
    },
  },
  {
    id: 4,
    name: "White Background Dance",
    kit: {
      "background stands": 2,
      "light stands": 4,
      "winders & prongs (set)": 1,
      lights: 4,
      umbrella: 4,
      tripod: 1,
      trigger: 1,
      clipboard: 1,
      "paper roll white": 1,
      scissors: 1,
      "floor brush": 1,
      tape: 1,
    },
  },
  {
    id: 5,
    name: "Green Screen",
    kit: {
      "background stands": 2,
      clipboard: 1,
      "green feet": 1,
      "light stands": 2,
      lights: 2,
      tape: 1,
      tripod: 1,
      umbrella: 2,
      "winders & prongs (set)": 1,
    },
  },
];

export default jobTypes;
